export { default } from './Warning';
